let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("azqRW")).then(() => parcelRequire('gVW5o'));